var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-create-room-error"},[_c('span',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]),_c('button',{staticClass:"bcx-button",on:{"click":_vm.buttonAction}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }